import Vue from 'vue'
import App from './App.vue'
import router from './routes';
import ElementUI from 'element-ui';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import './theme.scss';
import 'normalize.css';
import axios from 'axios';
import VueLazyLoad from 'vue-lazyload'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
Vue.use(VueLazyLoad, {
  loading: require('./assets/images/loading1.gif'),
  attempt: 1
})
Vue.prototype.$http = axios;
Vue.use(ElementUI);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
